import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/sales-invoice-status/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const salesInvoicesStatus = {
  getAll: apiPathFunc(pathBase),
} as const;
